const funcion = {
  FirmarDocumentos: 'FirmaEletronica/Funciones/FirmarDocumentos',
  ObtenerFirmantes: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerFirmantes',
  GuardarSolicitudFirmaMultiple: 'FirmaEletronica/Funciones/FirmaMultiple/GuardarSolicitud',
  ObtenerSolicitudesMultifirma: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerSolicitudes',
  ObtenerHistorialSolicitudesMultifirma: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerSolicitudes/Historial',
  ObtenerFirmantesSolicitudMultifirma: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerFirmantesSolicitud',
  ObtenerDocumentosSIOP: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerDocumentosSIOP',
  ObtenerDocumentosMajat: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerDocumentosMAJAT',
  ObtenerPathDocumentoMajat: 'FirmaEletronica/Funciones/FirmaMultiple/ObtenerPathDocumentoMajat',
  GuardarArchivosPEM: 'FirmaEletronica/Funciones/FirmaMultiple/GuardarArchivosPEM',
  GenerarEvidenciaMultifirma: 'FirmaEletronica/Funciones/FirmaMultiple/GenerarEvidencia',
  BajaSolicitudesFirma: 'FirmaEletronica/Funciones/FirmaMultiple/DeshabilitarSolicitudesFirma'
}

export default funcion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/firmaelectronica/funcion/funcion.js
// module id = null
// module chunks = 